import { render } from "./BusinessRegisterationProofUpload.vue?vue&type=template&id=095472b2&scoped=true"
import script from "./BusinessRegisterationProofUpload.vue?vue&type=script&lang=js"
export * from "./BusinessRegisterationProofUpload.vue?vue&type=script&lang=js"

import "./BusinessRegisterationProofUpload.vue?vue&type=style&index=0&id=095472b2&lang=scss&scoped=true"

import exportComponent from "D:\\Epaylater Projects\\microapp-web\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-095472b2"]])

export default __exports__